import { createActions, handleActions } from 'redux-actions';
import { createSelector } from 'reselect';

export const types = {
  OPEN_QUESTION_DIALOG: 'OPEN_QUESTION_DIALOG',
  OPEN_QUESTION_DIALOG_SUCCESS: 'OPEN_QUESTION_DIALOG_SUCCESS',
  CLOSE_QUESTION_DIALOG: 'CLOSE_QUESTION_DIALOG',
};

export const {
  openQuestionDialog,
  openQuestionDialogSuccess,
  closeQuestionDialog,
} = createActions(
  types.OPEN_QUESTION_DIALOG,
  types.OPEN_QUESTION_DIALOG_SUCCESS,
  types.CLOSE_QUESTION_DIALOG
);

const INIT_STATE = {
  questionDialogIsOpen: false,
};

const reducer = handleActions(
  {
    [types.OPEN_QUESTION_DIALOG_SUCCESS]: (state) => ({
      ...state,
      questionDialogIsOpen: true,
    }),
    [types.CLOSE_QUESTION_DIALOG]: (state) => ({
      ...state,
      questionDialogIsOpen: false,
    }),
  },
  INIT_STATE
);

export default reducer;
export const getQuestionDialog = (state) => state.questionDialog;
export const getQuestionDialogStatus = createSelector(
  getQuestionDialog,
  (questionDialog) => questionDialog.questionDialogIsOpen
);



// WEBPACK FOOTER //
// ./src/services/redux/questionDialog.js